import { DecimalPipe } from '@angular/common';
import { Directive, HostListener, Input } from '@angular/core';

//is used to fix cursor pointer
@Directive({
  selector: 'input[cursorPointer]',
  standalone: true,
})
export class CursorPointerDirective {
  @Input() cursorPointer: boolean;

  constructor(private decimalPipe: DecimalPipe) {}

  @HostListener('input', ['$event'])
  change(event) {
    if (!this.cursorPointer) return;

    const target = event.target;
    const posStart = target.selectionStart;
    const posEnd = target.selectionEnd;
    const oldLength = target.value.toString().split(',').length - 1;
    target.value = this.decimalPipe.transform(
      target.value.toString().replaceAll(',', '')
    );
    const newLength = target.value.toString().split(',').length - 1;
    let offset = newLength - oldLength;

    target.selectionStart = +posStart + (posStart + offset < 0 ? 0 : offset);
    target.selectionEnd = +posEnd + (posEnd + offset < 0 ? 0 : offset);
  }
}
